import { Icon } from '@material-ui/core';
import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navigations } from '../../Pages/RootRouting/navigations';
import { userList } from '../../Pages/RootRouting/RootRouting';
import AppContext from '../Context/AppContext';
import { ExtraDataContext } from '../Context/ExtraDataContext';
import SideNavExpand from './SideNavExpand';

const SideNavLayout = () => {
    const { isDarkTheme } = useContext(ExtraDataContext);
    const { ChildRouting } = useContext(AppContext);
    const { pathname } = useLocation();

    // RoleBase Navigation
    const getItems = navigations;
    const items = getItems && getItems.filter(data => {
        return data.auth && data.auth.find(p => {
            return p.includes(userList.role.find(pa => pa === p));
        })
    });

    //child route title
    const getFilterData = ChildRouting && ChildRouting.find((d) => pathname === d.path);

    const renderLevels = (data) => {
        return data.map((item, index) => {
            if (item.path === pathname || (getFilterData && getFilterData.parentRoute === item.path)) {
                document.title = `${item.name}`;
            }

            if (item.type === 'label')
                return (
                    <p
                        key={index}
                        className="text-center py-2 mb-2 text-muted textLabelStyle"
                    >
                        <span>{item.label}</span>
                    </p>
                )
            if (item.children) {
                return (
                    <SideNavExpand item={item} key={index} children={item.children} />
                )
            } else {
                return (
                    <div key={index} className={`${pathname === item.path || (getFilterData && getFilterData.parentRoute === item.path) ? 'activeNavBorder' : ''} `}>
                        <Link to={`${item.path}`}
                            className={`${pathname === item.path || (getFilterData && getFilterData.parentRoute === item.path) ? 'activeSideNav' : 'SideNavLink'}  d-flex align-items-center text-decoration-none sideNavPadding mx-3 px-2 ${isDarkTheme ? 'DEFAULT_DARK_LINK' : 'DEFAULT_LIGHT_LINK'}`}>
                            <Icon>{item.icon}</Icon> <span className="px-2">{item.name}</span>
                        </Link>
                    </div>
                )
            }
        })
    }

    return <div className="navigation mx-auto pt-2">{renderLevels(items)}</div>
};

export default SideNavLayout;